import type { ReactNode } from "react";
import { cx } from "./cx";

export interface KeyValueItem { label: ReactNode; value: ReactNode; mono?: boolean }

export function KeyValue({ items, columns = 1, className }: { items: KeyValueItem[]; columns?: 1 | 2; className?: string }) {
  return (
    <dl className={cx("ax-kv", columns === 2 && "ax-kv-2", className)}>
      {items.map((it, i) => (
        <KeyValueRow key={i} {...it} />
      ))}
    </dl>
  );
}

function KeyValueRow({ label, value, mono }: KeyValueItem) {
  return (
    <>
      <dt>{label}</dt>
      <dd className={cx(mono && "ax-mono")}>{value}</dd>
    </>
  );
}

export function SectionTitle({ children }: { children: ReactNode }) {
  return <p className="ax-section-title">{children}</p>;
}
